import { typography } from '@app/theme/tokens';

/** ISO/IEC 7810 ID-1 (credit-card) size. */
export const CARD_WIDTH_MM = 85.6;
export const CARD_HEIGHT_MM = 54;

/**
 * The card is designed on an 856 × 540 grid (10 units per mm). Every size is
 * expressed with `u()` in container-query units, so one layout renders
 * identically at preview width, at the fixed export width and at 85.6 mm in
 * print — no transforms, no per-surface copies.
 */
export const CARD_EXPORT_WIDTH_PX = 856;
export const CARD_EXPORT_HEIGHT_PX = 540;

/** Photo slot on the card (210 × 340 design px) — the admin cropper locks to this. */
export const CARD_PHOTO_ASPECT = 210 / 340;

export const u = (designPx: number) => `${+(designPx / (CARD_EXPORT_WIDTH_PX / 100)).toFixed(4)}cqw`;

export const cardColors = {
  navy: '#101C3A',
  blue: '#245FE8',
  /** Sampled from the balloon in the Trplin logo. */
  turquoise: '#02BCB1',
  text: '#101C3A',
  muted: '#64748B',
  subtle: '#94A3B8',
  border: '#E2E8F0',
  photoBg: '#E2E8F0',
  white: '#FFFFFF',
} as const;

export const cardFont = typography.fontBody;
